import getFilteredOrders from '~/src/lib/getFilteredOrders';
import isInApp from '~/src/lib/isInApp';

const isDisplayHeadbandOrder = (business, orders, router) => {
    //return true;
    // console.log('isDisplayHeadbandOrder');
    // console.log(todayTableOrder);

    if (isInApp()) {
        return false;
    }

    if (router && typeof router.route === 'string') {
        if (router.route === '/account/orders') {
            return false;
        }
        if (router.route === '/account/orders/detail') {
            return false;
        }
        if (router.route === '/account/orders/todayTableOrder') {
            return false;
        }
        if (router.route === '/account/orders/todayTakeawayOrder') {
            return false;
        }
        if (router.route === '/account/orders/todayUnpaidTableOrder') {
            return false;
        }
        if (router.route === '/cart') {
            return false;
        }
        if (router.route === '/checkout') {
            return false;
        }
        /*
        if(router.route === '/payment_success') {
            return false;
        }  
        */
    }

    //console.log(orders.length);

    if (typeof orders !== 'object') {
        return false;
    }

    if (orders.length > 0) {
        const todayTableOrder = getFilteredOrders(orders, {
            today: true,
            type: 'inside',
            status: 'not_delivered',
        });
        const takeawayOrder = getFilteredOrders(orders, {
            type: 'takeaway',
            status: 'not_delivered',
        });

        if (todayTableOrder.length > 0) {
            return true;
        }

        if (
            takeawayOrder.length > 0 &&
            +business.info.headband_takeaway === 1
        ) {
            return true;
        }

        return false;
    }

    return false;
};

export default isDisplayHeadbandOrder;
